import { Injectable } from '@angular/core';

import chroma from 'chroma-js';

@Injectable({
  providedIn: 'root',
})
export class BackgroundPatternService {
  public getWigglePattern(color: string, opacity: number): string {
    const colorHex = this.convertOklchStringToHex(color);
    const encodedHex = encodeURIComponent(colorHex);
    const pattern = `
      data:image/svg+xml,
      %3Csvg width='52' height='26' viewBox='0 0 52 26' xmlns='http://www.w3.org/2000/svg'%3E
        %3Cg fill='none' fill-rule='evenodd'%3E
          %3Cg fill='${encodedHex}' fill-opacity='${opacity}'%3E
            %3Cpath d='M10 10c0-2.21-1.79-4-4-4-3.314 0-6-2.686-6-6h2c0 2.21 1.79 4 4 4 3.314 0 6 2.686 6 6 0 2.21 1.79 4 4 4 3.314 0 6 2.686 6 6 0 2.21 1.79 4 4 4v2c-3.314 0-6-2.686-6-6 0-2.21-1.79-4-4-4-3.314 0-6-2.686-6-6zm25.464-1.95l8.486 8.486-1.414 1.414-8.486-8.486 1.414-1.414z' /%3E
          %3C/g%3E
        %3C/g%3E
      %3C/svg%3E`;

    return pattern.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
  }

  public getTexturePattern(color: string, opacity: number): string {
    const colorHex = this.convertOklchStringToHex(color);
    const encodedHex = encodeURIComponent(colorHex);
    const pattern = `
      data:image/svg+xml,
      %3Csvg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'%3E
        %3Cpath fill='${encodedHex}' fill-opacity='${opacity}' d='M1 3h1v1H1V3zm2-2h1v1H3V1z'%3E
        %3C/path%3E
      %3C/svg%3E`;

    return pattern.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
  }

  public getBubblesPattern(color: string, opacity: number): string {
    const colorHex = this.convertOklchStringToHex(color);
    const encodedHex = encodeURIComponent(colorHex);
    const pattern = `
      data:image/svg+xml,
      %3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E
        %3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='${encodedHex}' fill-opacity='${opacity}' fill-rule='evenodd'/%3E
      %3C/svg%3E`;

    return pattern.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
  }

  public getBankNotePattern(color: string, opacity: number): string {
    const colorHex = this.convertOklchStringToHex(color);
    const encodedHex = encodeURIComponent(colorHex);
    const pattern = `
      data:image/svg+xml,
      %3Csvg width='100' height='20' viewBox='0 0 100 20' xmlns='http://www.w3.org/2000/svg'%3E
        %3Cpath d='M21.184 20c.357-.13.72-.264 1.088-.402l1.768-.661C33.64 15.347 39.647 14 50 14c10.271 0 15.362 1.222 24.629 4.928.955.383 1.869.74 2.75 1.072h6.225c-2.51-.73-5.139-1.691-8.233-2.928C65.888 13.278 60.562 12 50 12c-10.626 0-16.855 1.397-26.66 5.063l-1.767.662c-2.475.923-4.66 1.674-6.724 2.275h6.335zm0-20C13.258 2.892 8.077 4 0 4V2c5.744 0 9.951-.574 14.85-2h6.334zM77.38 0C85.239 2.966 90.502 4 100 4V2c-6.842 0-11.386-.542-16.396-2h-6.225zM0 14c8.44 0 13.718-1.21 22.272-4.402l1.768-.661C33.64 5.347 39.647 4 50 4c10.271 0 15.362 1.222 24.629 4.928C84.112 12.722 89.438 14 100 14v-2c-10.271 0-15.362-1.222-24.629-4.928C65.888 3.278 60.562 2 50 2 39.374 2 33.145 3.397 23.34 7.063l-1.767.662C13.223 10.84 8.163 12 0 12v2z' fill='${encodedHex}' fill-opacity='${opacity}' fill-rule='evenodd'/%3E
      %3C/svg%3E`;

    return pattern.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
  }

  public getHideoutPattern(color: string, opacity: number): string {
    const colorHex = this.convertOklchStringToHex(color);
    const encodedHex = encodeURIComponent(colorHex);
    const pattern = `
      data:image/svg+xml,
      %3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3E
        %3Cg fill-rule='evenodd'%3E
          %3Cg fill='${encodedHex}' fill-opacity='${opacity}'%3E
            %3Cpath d='M0 38.59l2.83-2.83 1.41 1.41L1.41 40H0v-1.41zM0 1.4l2.83 2.83 1.41-1.41L1.41 0H0v1.41zM38.59 40l-2.83-2.83 1.41-1.41L40 38.59V40h-1.41zM40 1.41l-2.83 2.83-1.41-1.41L38.59 0H40v1.41zM20 18.6l2.83-2.83 1.41 1.41L21.41 20l2.83 2.83-1.41 1.41L20 21.41l-2.83 2.83-1.41-1.41L18.59 20l-2.83-2.83 1.41-1.41L20 18.59z'/%3E
          %3C/g%3E
        %3C/g%3E
      %3C/svg%3E`;

    return pattern.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
  }

  public getFourPointsStarsPattern(color: string, opacity: number): string {
    const colorHex = this.convertOklchStringToHex(color);
    const encodedHex = encodeURIComponent(colorHex);
    const pattern = `
      data:image/svg+xml,
      %3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E
        %3Cg fill='${encodedHex}' fill-opacity='${opacity}'%3E
          %3Cpolygon fill-rule='evenodd' points='8 4 12 6 8 8 6 12 4 8 0 6 4 4 6 0 8 4'/%3E
        %3C/g%3E
      %3C/svg%3E`;

    return pattern.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
  }

  public getPlusPattern(color: string, opacity: number): string {
    const colorHex = this.convertOklchStringToHex(color);
    const encodedHex = encodeURIComponent(colorHex);
    const pattern = `
      data:image/svg+xml,
      %3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E
        %3Cg fill='none' fill-rule='evenodd'%3E
          %3Cg fill='${encodedHex}' fill-opacity='${opacity}'%3E
            %3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E
          %3C/g%3E
        %3C/g%3E
      %3C/svg%3E`;

    return pattern.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
  }

  public getPolkaDotsPattern(color: string, opacity: number = 0.4): string {
    const colorHex = this.convertOklchStringToHex(color);
    const encodedHex = encodeURIComponent(colorHex);
    const pattern = `
      data:image/svg+xml,
      %3Csvg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E
        %3Cg fill='${encodedHex}' fill-opacity='${opacity}' fill-rule='evenodd'%3E
          %3Ccircle cx='3' cy='3' r='3'/%3E
          %3Ccircle cx='13' cy='13' r='3'/%3E
        %3C/g%3E
      %3C/svg%3E`;

    return pattern.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
  }

  private convertOklchStringToHex(oklchString: string): string {
    const parts = oklchString.split(' ');
    const l = parseFloat(parts[0]);
    const c = parseFloat(parts[1]);
    const h = parseFloat(parts[2]);

    return this.convertOklchToHex(l / 100, c, h);
  }

  private convertOklchToHex(l: number, c: number, h: number): string {
    const rgb = chroma.oklch(l, c, h).rgb();

    return chroma(rgb).hex();
  }
}
